export default __webpack_public_path__ + "media/src/assets/images/Sent-39445d24b3fa6fdaaf4f273bb53a1868.svg";